export const REGIONS = ["Topic1", "Topic2"];

export default REGIONS;
